<aim-spinner></aim-spinner>
<h1>{{title}}</h1>
